/** Beschriftungen der Container-Felder — 1:1 aus den `[Caption(...)]`-Attributen der DLL. */

import type { CaptionMap } from '../captions';
import type { Container } from '../entities';

const captions = {
  AenderungCif: 'CIF Changed',
  Anlieferdatum: 'Container Delivery Date',
  AnlieferdatumEmpf: 'Container Delivery Recipient',
  AnlieferdatumIst: 'Actual Delivery Date',
  Anlieferuhrzeit: 'Delivery Time',
  Bemerkung: 'Remark',
  Bestellpositionen: 'Positions',
  Bestellpositionen_Anzahl: 'Position Count',
  Bestellpositionen_Artikelnummern: 'Position Item Numbers',
  Bestellpositionen_Bezeichnungen1: 'Position Item Titles',
  Bestellpositionen_CBM: 'Position CBM',
  Bestellpositionen_Mengen: 'Position Item Quantities',
  Bestellpositionen_SageBuchungDatum: 'Position Sage Booking Date',
  BlNummer: 'BL Number',
  Containerleerrueckgabe: 'Empty Return',
  ContainerNo: 'Container Number',
  ContReturnDatum: 'Return Date',
  ContTyp: 'Container Type',
  DatumZugestellt: 'Delivery Date',
  DepotDatum: 'Depot Date',
  DepotName: 'Depot Name',
  EingangErledigt: 'Entrance Completed',
  Empfaenger: 'Recipient',
  Entladedatum: 'Discharge Date',
  Eta: 'ETA',
  Etd: 'ETD',
  FruehestAnlieferdatum: 'Earliest Delivery Date',
  GateOutDatum: 'Gate Out Date',
  InWochen: 'Weeks',
  Kw: 'Week',
  LieferterminContainer: 'Delivery Appointment',
  NaechsteKw: 'Next Week',
  NlSp: 'NlSp',
  NlSpPos: 'NlSp Position',
  Plombe: 'Seal',
  PoD: 'PoD',
  Rechnungen: 'Receipts',
  Reeder: 'Ship Owner',
  RueckgabeReferenz: 'Empty Return Reference',
  Schiff: 'Ship',
  Spediteur: 'Freight Forwarder',
  TerminBestaetigungCif: 'Appointment Confirmation CIF',
} satisfies Partial<Record<keyof Container, string>>;

export const containerCaptions: CaptionMap = captions;
